export default __webpack_public_path__ + "static/media/screen2.84c224a6.png";